module.exports = __webpack_public_path__ + "static/media/IFM.fcba3532.png";